function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-ab6b49ac\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!../../../node_modules/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./SearchYoutubePlayer.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!../../../node_modules/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./SearchYoutubePlayer.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ab6b49ac\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!../../../node_modules/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./SearchYoutubePlayer.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ab6b49ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/search/SearchYoutubePlayer.vue
// module id = 633
// module chunks = 0